<!-- Toolbar -->
<mat-toolbar color="primary" class="app-header" *ngIf="token">
  <nav class="navbar" style="display: flex; align-items: center; justify-content: space-between;" >
  

    <div class="nav-tool-items" *ngIf="token && loginCompany === '3'">
      <!-- Dropdown Trigger -->
      <button mat-button [matMenuTriggerFor]="dashboardMenu" class="dashboardMenu">
        {{selectedValue.viewValue}} ▼
      </button>

      <!-- Dropdown Menu -->
      <mat-menu #dashboardMenu="matMenu">
        @for (org of organizations; track org) {
            <button mat-menu-item (click)="changeOrganization(org.value); selectedValue = org">
            {{ org.viewValue }}
            </button>
        }
      </mat-menu>
    </div>

    <!-- Menu Section (If User is Logged In) -->
    <div class="nav-tool-items" *ngIf="token">
      <!-- Dropdown Trigger -->
      <button mat-button [matMenuTriggerFor]="userMenu" class="username">
        Hi {{user}} ▼
      </button>

      <!-- Dropdown Menu -->
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item disabled>
          <mat-icon>person</mat-icon>
          <span>{{ user }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Log out</span>
        </button> 
      </mat-menu>
    </div>
  </nav>
</mat-toolbar>


<div class="main-content" *ngIf="organizations">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
</div>